import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { DocumentsList, Document } from '@/interfaces/documents'
import {DocumentService} from '@/services/DocumentService'

export const useDocumentStore = defineStore('documentStore', () => {
  const getDocuments = async (folder:string) => {
    return await DocumentService.getDocuments(encodeURIComponent(folder));
  }
  const getDataUrl = async (document: Document) => {
    return await DocumentService.getDataUrl(document.id, document.originalName);
  }
  const download = async (document: Document) => {
    return await DocumentService.download(document.id, document.originalName + document.extension);
  }


  return {
    getDocuments,
    getDataUrl,
    download
  }
})
